<app-loader *ngIf="loaderIcon | async"></app-loader>

<div class="vendorSearch" *ngIf="customerSearch">
  <!-- Filter Section -->
  <div class="row mb-2">

    <div class="col-md-3">
      <label>Search Field</label>
      <select class="form-select form-select-sm" [(ngModel)]="searchField">
        <option value="MarketCustomerId">Customer ID</option>
        <option value="FirstName">First Name</option>
        <option value="LastName">Last Name</option>
        <option value="CompanyName">Company Name</option>
        <option value="Telephone">Telephone</option>
        <option value="Mobile">Mobile</option>
        <option value="Email">Email</option>
        <option value="City">City</option>
        <option value="State">State</option>
        <option value="Zip Code">Zipcode</option>
      </select>
    </div>

    <div class="col-md-3">
      <label>Search Value</label>
      <input type="text" class="form-control form-control-sm" [(ngModel)]="searchValue" (keyup.enter)="resetAndLoad()">
    </div>
  </div>

  <!-- Scrollable Table -->
  <div class="row">
    <div class="col-12">
      <div class="scroll_outer" style="height:400px; overflow-y:auto;" #scrollContainer (scroll)="onScroll()">
        <table class="table table-striped text-center mb-0">
          <thead style="position: sticky; top: 0; z-index: 9; background-color: #fff;">
          <tr>
            <th style="width: 6%" (click)="sort('MarketCustomerId')">Customer ID</th>
            <th style="width: 10%" (click)="sort('FirstName')">First Name</th>
            <th style="width: 10%" (click)="sort('LastName')">Last Name</th>
            <th style="width: 20%" (click)="sort('Address')">Address</th>
            <th style="width: 10%" (click)="sort('City')">City</th>
            <th style="width: 8%" (click)="sort('StateId')">State</th>
            <th style="width: 8%" (click)="sort('CountryId')">Country</th>
            <th style="width: 8%" (click)="sort('Zip')">Zip</th>
            <th style="width: 10%" (click)="sort('Telephone')">Telephone</th>
            <th style="width: 10%" (click)="sort('CellPhone')">Cell Phone</th>
            <th style="width: 12%" (click)="sort('Email')">Email</th>
            <th style="width: 12%" (click)="sort('TaxExemptionNumber')">Tax Exemption #</th>
          </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of data" class="customer-row" (click)="CustomerDetails(item, $event)">
              <td>{{ item.MarketCustomerId }}</td>
              <td>{{ item.FirstName }}</td>
              <td>{{ item.LastName }}</td>
              <td class="text-left">{{ item.Address }}</td>
              <td>{{ item.City }}</td>
              <td>{{ item.StateId }}</td>
              <td>{{ item.CountryId }}</td>
              <td>{{ item.Zip }}</td>
              <td>{{ item.Telephone }}</td>
              <td>{{ item.CellPhone }}</td>
              <td class="text-left">{{ item.Email }}</td>
              <td>{{ item.TaxExemptionNumber }}</td>
            </tr>
            <tr *ngIf="data.length == 0">
              <td colspan="12" style="text-align: center;">No records found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="form-container" *ngIf="!customerSearch">
  <div [formGroup]="customerForm">
    <div class="row g-3 align-items-center">
      <div class="col-md-3">
        <label class="form-label">Customer #</label>
        <div class="input-group">
          <input type="text" class="form-control" formControlName="marketCustomerId">
        </div>
      </div>

      <div class="col-md-3">
        <label class="form-label">Tax Exemption #</label>
        <input type="text" class="form-control" formControlName="taxExemptionNumber" maxlength="22">
      </div>

      <div class="col-md-3 d-flex align-items-center mt-4">
        <input class="form-check-input me-2" type="checkbox" formControlName="inactiveCustomer">
        <label class="form-check-label">Inactive Customer</label>
      </div>

      <div class="col-md-3 text-center">
        <div class="d-flex align-items-start justify-content-start">
      
          <!-- Image Box -->
          <div class="me-3">
            <div class="Image-box position-relative" style="width: 120px; height: 120px;">
              <input *ngIf="isDefaultImage" type="file" accept=".jpg,.jpeg,.png" (change)="addImage($event)"
                class="form-control position-absolute top-0 start-0 w-100 h-100 opacity-0" style="cursor: pointer;">
              <div class="w-100 d-flex align-items-center justify-content-center" [ngClass]="{'no-photo': isNoPhoto}">
                <img [src]="imagePreviewUrl" id="ImagePreview" class="img-fluid rounded shadow-sm"
                  style="pointer-events: none; max-height: 100%; object-fit: cover;">
              </div>
            </div>
          </div>
      
          <!-- Buttons -->
          <div class="text-start">
            <input type="file" id="ImageFileInput" (change)="addImage($event)" accept=".jpg,.jpeg,.png" hidden>
      
            <ejs-tooltip id='tooltipMImageAdd' target="#btnMImageAdd" position='RightCenter' openMode="Auto"
              windowCollision="fit" (beforeOpen)="onBeforeOpen($event)">
              <button id="btnMImageAdd" class="btn btnAS btn-sm mb-2" type="button" (click)="addImageClick()">{{imageAddbtnText}}</button>
            </ejs-tooltip>
      
            <br />
      
            <ejs-tooltip id='tooltipMImageRemove' target="#btnMImageRemove" position='RightCenter' openMode="Auto"
              windowCollision="fit" (beforeOpen)="onBeforeOpen($event)">
              <button id="btnMImageRemove" class="btn btnAS btn-sm" type="button" (click)="removeImage()"
                [disabled]="!canRemoveImage">REMOVE</button>
            </ejs-tooltip>
          </div>
      
        </div>
      </div>

    </div>
    <div class="row g-3">
      <div class="col-md-4">
        <label class="form-label"><span style="color: red;">*</span>First Name</label>
        <input type="text" class="form-control" [class.is-invalid]="customerForm.get('firstName')?.invalid" formControlName="firstName" maxlength="50">
        <div class="invalid-feedback">First Name is required.</div>
      </div>
      <div class="col-md-4">
        <label class="form-label">Last Name</label>
        <input type="text" class="form-control" formControlName="lastName" maxlength="50">
      </div>
    </div>

    <div class="row g-3 mt-1">
      <div class="col-md-4">
        <label class="form-label">Company Name</label>
        <input type="text" class="form-control" formControlName="companyName" maxlength="50">
      </div>
      <div class="col-md-4">
        <label class="form-label">Email Address</label>
        <input type="email" class="form-control" [class.is-invalid]="customerForm.get('email')?.invalid" formControlName="email" maxlength="50">
        <div class="invalid-feedback">Invalid email address.</div>
      </div>
      <div class="col-md-4">
        <label class="form-label">Driver License #</label>
        <input type="text" class="form-control" formControlName="driverLicenseNo" maxlength="20">
      </div>
    </div>

    <div class="row g-3 mt-1">
      <div class="col-md-4">
        <label for="country" class="form-label">Country</label>
        <select class="form-select" id="country" formControlName="countryId" (change)="onCountryChange()">
          <option [value]="null" disabled selected>Select</option>
          @for (c of countries; track c.Code) {
          <option [value]="c.Code">{{ c.Name }}</option>
          }
        </select>
      </div>
      <div class="col-md-4">
        <label class="form-label">City</label>
        <input type="text" class="form-control" formControlName="city" maxlength="20">
      </div>
      <div class="col-md-4">
        <label class="form-label">State</label>
        <select class="form-select" id="state" formControlName="stateId" *ngIf="showStateDropDown"
          [class.is-invalid]="customerForm.get('stateId')?.invalid">
          <option [value]="null" disabled selected>Select</option>
          @for (state of states; track state.StateCode) {
          <option [value]="state.StateCode">{{ state.StateCode }}</option>
          }
        </select>
        <div class="invalid-feedback" *ngIf="showStateDropDown && customerForm.get('stateId')?.errors?.['required']">State is required.</div>
        <input type="text" *ngIf="!showStateDropDown" maxlength="2" tabindex="9" class="form-control"
          [class.is-invalid]="customerForm.get('stateCode')?.invalid"
          formControlName="stateCode">
        <div class="invalid-feedback" *ngIf="!showStateDropDown && customerForm.get('stateCode')?.errors?.['required']">State is required.</div>
      </div>
    </div>

    <div class="row g-3 mt-1">
      <div class="col-md-3">
        <label class="form-label">ZipCode</label>
        <input type="text" class="form-control" [class.is-invalid]="customerForm.get('zip')?.invalid" formControlName="zip" maxlength="50">
        <div class="invalid-feedback" *ngIf="customerForm.get('zip')?.errors?.['pattern']">Invalid zip code format.</div>
      </div> 
      <div class="col-md-3">
        <label class="form-label">DL Expiry Date</label>
        <ejs-datepicker
          class="form-control p-0"
          formControlName="driverLicenseExpiryDate"
          format="MM/dd/yyyy"
          placeholder="MM/DD/YYYY"
          [strictMode]="true">
        </ejs-datepicker>
      </div>
      <div class="col-md-6">
        <label class="form-label">Address</label>
        <textarea class="form-control" rows="2" formControlName="address" maxlength="50"></textarea>
      </div>      
    </div>

    <div class="row g-3 mt-1">
      <div class="col-md-3">
        <label class="form-label">Telephone</label>
        <ejs-maskedtextbox
          [mask]="PhoneNumberMask"
          [promptChar]="'_'"
          placeholder="(000)000-0000"
          name="telephone"
          id="telephone"
          formControlName="telephone">
        </ejs-maskedtextbox>
        <div class="text-danger mt-1"
          *ngIf="customerForm.get('telephone')?.errors?.['invalidPhone'] && (customerForm.get('telephone')?.dirty || customerForm.get('telephone')?.touched)">
          Please enter a valid phone number.
        </div>
      </div>
      <div class="col-md-3">
        <label class="form-label">Mobile</label>
        <ejs-maskedtextbox
          [mask]="PhoneNumberMask"
          [promptChar]="'_'"
          placeholder="(000)000-0000"
          name="cellPhone"
          id="cellPhone"
          formControlName="cellPhone">
        </ejs-maskedtextbox>
        <div class="text-danger mt-1"
          *ngIf="customerForm.get('cellPhone')?.errors?.['invalidPhone'] && (customerForm.get('cellPhone')?.dirty || customerForm.get('cellPhone')?.touched)">
          Please enter a valid mobile number.
        </div>
      </div>
    </div>

    <div class="row g-3 mt-1">
      <div class="col-12">
        <label class="form-label">Notes</label>
        <textarea class="form-control" rows="2" formControlName="customerNotes"></textarea>
      </div>
    </div>

    <div class="row g-3 mt-1">
      <div class="col-md-12 text-end">
        <button type="button" class="btn btnAS me-1" [disabled]="validateForm() || isSavingCustomer" (click)="saveCustomerDetails()">Save</button>
        <button type="button" class="btn btn-orange" (click)="closeCustomerModal()">Close</button>
      </div>
    </div>
  </div>
</div>